import Vue from 'vue/dist/vue.esm.js'
const d = document

const is_input = document.querySelector('.mw_wp_form').classList.contains('mw_wp_form_input')
const is_confirm = document.querySelector('.mw_wp_form').classList.contains('mw_wp_form_confirm')

const init = () => {
  // const input_template = d.querySelector('#input')
  // const input_templateDOM = new DOMParser().parseFromString( input_template.innerHTML, 'text/html' )
  // const payment_bank_children = JSON.parse( input_templateDOM.querySelector('[name="__children[お支払い方法：口座振替][]"]').value )
  // const store_children = JSON.parse( input_templateDOM.querySelector('[name="__children[お支払い方法：店頭支払い][]"]').value )
  const payment_bank_children = {
    '': '選択してください',
    '1年一括払い': '1年一括払い',
    '毎月支払い': '毎月支払い',
  }
  const store_children = {
    '': '受け取り店舗を選択してください',
    '浜松本店': '浜松本店 | 浜松市中区砂山町6-1メイワン８階',
    'イオンモール浜松志都呂店': 'イオンモール浜松志都呂店 | 浜松市西区志都呂2-37-1',
    'サンストリート浜北店': 'サンストリート浜北店 | 浜松市浜北区平口2861',
    '連尺店': '連尺店 | 浜松市中区連尺町309-1',
    '三方原店': '三方原店 | 浜松市北区三方原町759-1',
    '本沢合店': '本沢合店 | 浜松市浜北区本沢合123-2',
    'エキマチ店': 'エキマチ店 | 浜松市中区砂山町6-1メイワンエキマチ内',
    '聖隷浜松病院売店': '聖隷浜松病院売店 | 浜松市中区住吉2-12-12',
    '聖隷三方原病院売店': '聖隷三方原病院売店 | 浜松市北区三方原町3453',
    '浜松医大福利棟売店': '浜松医大福利棟売店 | 浜松市東区半田山1丁目20番1号',
    'ららぽーと磐田店': 'ららぽーと磐田店 | 磐田市高見丘1200　ららぽーと磐田1階',
    'アピタ磐田店': 'アピタ磐田店 | 磐田市今之浦三丁目1-11　アピタ磐田1階',
    '磐田店': '磐田店 | 磐田市国府台58-2',
  }
  
  const edit_template = d.querySelector('#paymentEdit')
  const edit_templateDOM = new DOMParser().parseFromString( edit_template.innerHTML, 'text/html' )

  $('select[name="お支払い方法：口座振替"]',edit_templateDOM).each( (i,obj) => {
    $.each(payment_bank_children, (key,val) => $(obj).append( $(`<option value="${key}">${val}</option>`)[0] ))
  })
  $('select[name="お支払い方法：店頭支払い"]',edit_templateDOM).each( (i,obj) => {
    $.each(store_children, (key,val) => $(obj).append( $(`<option value="${key}">${val}</option>`)[0] ))
  })

  edit_template.innerHTML = edit_templateDOM.body.outerHTML
}

if( is_confirm ) init()

export default Vue.component( 'paymentEdit', {
  template: '#paymentEdit',
  props:{
    is_input: Boolean,
    is_confirm: Boolean,
    formdata: Object
  },
  data () {
    return {
      editdata: {
        payment: this.formdata.payment,
        payment_bank: this.formdata.payment_bank,
        store: this.formdata.store,
      }
    }
  },
  mounted () {
    if( is_input ) this.$router.replace('/')
  },
  methods: {
    update(){
      this.$emit('upd-section', this.editdata)
      this.$router.push('/')
    }
  }
})


